// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.siKyaAG6fPYGixV22nb4{padding:8px 8px 12px}.JvpWwM_irv0zCu7Z1e7K{justify-content:space-between;margin-bottom:12px;display:flex}.m91gYdMHeSowbZUehBbM{flex-direction:column}.C2dfPM3qHcGxEHIrR3y1{max-height:300px;padding-left:4px;padding-right:4px;overflow-y:auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `siKyaAG6fPYGixV22nb4`,
	"header": `JvpWwM_irv0zCu7Z1e7K`,
	"header--short": `m91gYdMHeSowbZUehBbM`,
	"headerShort": `m91gYdMHeSowbZUehBbM`,
	"response": `C2dfPM3qHcGxEHIrR3y1`
};
export default ___CSS_LOADER_EXPORT___;
